import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { SERVICE_TYPES } from "@/data/services";
import { portalInputCls } from "@/components/portal/PortalBits";

export function NewQuoteForm({ onCreated }) {
  const [f, setF] = useState({
    pickup_location: "", dropoff_location: "", service_type: SERVICE_TYPES[0],
    cargo_type: "", weight: "", pickup_date: "", notes: "",
  });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.pickup_location || !f.dropoff_location) { toast.error("Pickup and drop-off are required"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/client/quotes", f);
      onCreated(data);
    } catch (err) {
      console.error("Quote submit failed:", err);
      toast.error(typeof err?.response?.data?.detail === "string" ? err.response.data.detail : "Submit failed");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} data-testid="portal-new-quote-form" className="border border-slate-200 bg-white p-6 lg:p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Pickup location *</div>
        <input required value={f.pickup_location} onChange={upd("pickup_location")} className={portalInputCls} data-testid="portal-quote-pickup" />
      </label>
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Drop-off location *</div>
        <input required value={f.dropoff_location} onChange={upd("dropoff_location")} className={portalInputCls} data-testid="portal-quote-dropoff" />
      </label>
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Service type</div>
        <select value={f.service_type} onChange={upd("service_type")} className={portalInputCls} data-testid="portal-quote-service">
          {SERVICE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </label>
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Preferred pickup date</div>
        <input type="date" value={f.pickup_date} onChange={upd("pickup_date")} className={portalInputCls} data-testid="portal-quote-date" />
      </label>
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Cargo type</div>
        <input value={f.cargo_type} onChange={upd("cargo_type")} className={portalInputCls} data-testid="portal-quote-cargo" />
      </label>
      <label>
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Weight / size</div>
        <input value={f.weight} onChange={upd("weight")} className={portalInputCls} data-testid="portal-quote-weight" />
      </label>
      <label className="md:col-span-2">
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Additional notes</div>
        <textarea rows={4} value={f.notes} onChange={upd("notes")} className={portalInputCls + " resize-none"} data-testid="portal-quote-notes" />
      </label>
      <div className="md:col-span-2 flex justify-end">
        <button type="submit" disabled={loading} data-testid="portal-quote-submit"
          className="inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] disabled:opacity-60 text-white px-8 py-4 font-bold uppercase tracking-wider text-sm">
          {loading ? "Sending…" : "Send Quote Request"} <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </form>
  );
}
